import { FileText } from "lucide-react";
import { motion } from "framer-motion";

type MessageProps = {
  role: "assistant" | "user";
  content: string;
};

const ChatMessage = ({ role, content }: MessageProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className={`flex ${role === "assistant" ? "justify-start" : "justify-end"}`}
    >
      <div
        className={`max-w-[80%] rounded-lg p-4 ${
          role === "assistant"
            ? "bg-accent/10 text-white"
            : "bg-primary text-white"
        }`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </motion.div>
  );
};

export default ChatMessage;